module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IdmBqJ/tc-custom/9781780108995.jpg?1704585954258",
      "alt": "This image is the cover for the book Season of Sacrifice, The Maya Mallick Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Season of Sacrifice, The Maya Mallick Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("Introducing feisty Asian-American private investigator Maya Mallick in the first of an intriguing new mystery series.")])]), _c('br'), _c('br'), _vm._v(" During a morning stroll in Seattle’s Green Lake district, Maya Mallick is horrified to see two young women, shrouded in white, set themselves ablaze in front of the temporary residence of the visiting Chinese foreign minister. She’s even more shocked to recognize one of them: Sylvie Burton, a brilliant Tibetan-American biomedical scientist, who is the adopted sister of Maya’s best friend."), _c('br'), _c('br'), _vm._v(" An onlooker informs her that the two women are martyrs, protesting the Chinese occupation of Tibet. Yet Maya has a nagging suspicion that all is not as it seems. With so much to live for, why would Sylvie wish to end her life in this horrific way? "), _c('br'), _c('br'), _vm._v(" As Maya gets closer to the shocking truth, she finds her own life on the line.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bharti Kirchner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bharti Kirchner is the author of five previous novels and four cookbooks. An award-winning cook, she has written numerous magazine articles and essays on food, travel, fitness and lifestyle. Born and brought up in Kolkata (formerly Calcutta), India, she now lives in Seattle, Washington.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Severn House\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0